import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DashboardMilestone } from './rest/rest.service';

@Injectable({ providedIn: 'root' })
export class UserMilestoneBadgesService {
  private readonly badges$ = new BehaviorSubject<DashboardMilestone[]>([]);

  readonly recentMilestones$ = this.badges$.asObservable();

  setRecentMilestones(milestones: DashboardMilestone[]): void {
    this.badges$.next(milestones ?? []);
  }
}
